import React, { useCallback, useRef, useState } from 'react';
import { Dialog, PropertyGrid, TextInput } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.OperatingHoursEditor');
export default function AddModeDialog(props) {
  const {
    show,
    onClose,
    name,
    onChange,
    mode,
    modes = {},
    eventData,
    usage = 'add'
  } = props;
  const ref = useRef();
  const [isInError, setIsInError] = useState(false);
  const [value, setValue] = useState(mode || (Object.keys(modes).length > 0 ? null : 'Default'));
  const onChangeValue = useCallback(({
    value: val
  }) => {
    setValue(val);
    if (val === '' || modes[val] != null) {
      setIsInError(true);
    }
  }, [modes]);
  const onOkay = useCallback(() => {
    onChange?.({
      value,
      data: eventData
    });
    onClose();
  }, [onChange, onClose, value, eventData]);
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    variant: "itemForm",
    headerVariant: "itemFormHeader|formHeader",
    bodyVariant: "dialogFormBody|itemFormBody|formBody",
    footerVariant: "itemFormFooter|formButtons",
    okay: t('create', {
      context: usage
    }),
    title: /*#__PURE__*/React.createElement(TitleBar, {
      variant: "dialogTitle",
      title: t('addMode', {
        context: usage
      }),
      icon: tIcon(usage === 'update' ? 'updateModeFormIcon' : 'addModeFormIcon', usage === 'update' ? 'fa fa-fw fa-pencil' : 'fa fa-fw fa-plus')
    }),
    show: show,
    onClose: onClose,
    onCancel: onClose,
    okayDisabled: isInError || !value || value === '',
    onOkay: onOkay
  }, /*#__PURE__*/React.createElement(PropertyGrid, {
    vertical: true,
    variant: "addMode"
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: name,
    stretch: true
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: value,
    onChange: onChangeValue,
    validator: value => {
      return modes[titleCaseToCamelCase(value)] == null;
    },
    domRef: ref
  }))));
}
function titleCaseToCamelCase(string = '') {
  const parts = string.split(/\s/g);
  const capped = parts.map((item, index) => {
    return item.charAt(0)[index === 0 ? 'toLowerCase' : 'toUpperCase']() + item.slice(1);
  });
  return capped.join('');
}